<template>
    <div :class="`sub-menu-item ${isActive ? 'active' : ''}`">
        <typo name="menu-14-normal">
            <slot></slot>
        </typo>
    </div>
</template>

<script>
import Vue from "vue";
export default Vue.extend({
    props: ["isActive"],
});
</script>

<style lang="sass" scoped>
.sub-menu-item
    min-height: 60px
    display: flex
    align-items: center
    padding-left: 20px
    padding-right: 20px
    text-align: center
    color: $color-secondary
    transition: color .15s ease
    +r(1140)
        border-top: 1px solid $color-grey
.active
    color: $color-main
</style>